const initialReportState = {
  data : false,
  columns: false
}

export const ReportReducer = (state = initialReportState, action = {}) => {
  let data = state.data;
  switch (action.type) {    
        
        case 'REPORT_DATA':  

            return {
              ...state,
              data: action.payload.data.reportTypes,
              columns: action.payload.data.columns

            }
        case 'ADD_NEW_REPORT':
          data.push(action.payload);
          return {
            ...state,
            data: data
          }
        case 'UPDATE_REPORT':
          data[action.payload.index] = action.payload.data
          return {
            ...state,
            data: data
          }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReportReducer.js